import createStore from 'redux-zero';
import bio from './DataBase';

const MESSAGE = [];

const initialState = {
    selectedSection: 1,
    isSpanish: false,
    bio: bio,
    /*messages: {
        id: null,
        name: null,
        email: null,
        message: null
    }*/
    messages : MESSAGE
};

const store = createStore(initialState);
export default store;


// WEBPACK FOOTER //
// ./src/store/store.js